import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { setAccessAllowed } from '../services/subscriptionService';
import './SubscriptionPage.css';
import { logVisit } from '../services/visitorLogService';

// Function to generate random alphanumeric string
const generateRefId = (length = 20) => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  for (let i = 0; i < length; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
};

const DTACSubscriptionPage = () => {
  const navigate = useNavigate();
  const hasLogged = useRef(false);
  const [refId] = useState(() => generateRefId(20));
  
  useEffect(() => {
    // Log the visit when component mounts (prevent double execution)
    if (!hasLogged.current) {
      hasLogged.current = true;
      logVisit(refId);
    }
  }, [refId]);
  
  const handleGoBack = () => {
    navigate(-1);
  };
  
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleSubscribe = async () => {
    setIsLoading(true);
    setError(null);
    
    try {
      
      // Call the subscription API (GET request)
      const apiUrl = process.env.REACT_APP_AUTH_TOKEN_API || 'https://api.gamerclub.mobi/api/dn/th/auth/token';
      const response = await fetch(apiUrl);
      
      if (!response.ok) {
        throw new Error('Subscription failed. Please try again.');
      }
      
      const data = await response.json();
      
      // Get the token from the response
      const token = data.tokenResponse.split(',')[0];
      
      // Use the subscription callback route as required
      const baseUrl = 'https://gamerclub.mobi';
      const callbackUrl = encodeURIComponent(`${baseUrl}/subscription/callback?token=${token}&refid=${refId}`);
      
      // Redirect to the DTAC payment URL with the callback URL
      const paymentUrl = process.env.REACT_APP_DTAC_PAYMENT_URL || 'http://mis.etracker.cc/THwap/WAPMORequest.aspx';
      const keyword = process.env.REACT_APP_DTAC_KEYWORD || 'YG3';
      const shortcode = process.env.REACT_APP_DTAC_SHORTCODE || '4541392';
      const telcoId = process.env.REACT_APP_DTAC_TELCOID || '1';
     // alert(`${paymentUrl}?Telcoid=${telcoId}&Shortcode=${shortcode}&Keyword=${keyword}&refid=${refId}&AuthToken=${token}`);
//http://mis.etracker.cc/THwap/WAPMORequest.aspx?Telcoid=1&Shortcode=4541392&Keyword=YG2&refid=GUWE1FxMCfAQQkE3OJSF&AuthToken=
      // window.location.href = `${paymentUrl}?Keyword=${keyword}&Shortcode=${shortcode}&CallBackURL=${callbackUrl}`;
      window.location.href =  `${paymentUrl}?Telcoid=${telcoId}&Shortcode=${shortcode}&Keyword=${keyword}&refid=${refId}&AuthToken=${token}`;
    } catch (err) {
      setError(err.message || 'An error occurred during subscription');
      console.error('Subscription error:', err);
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <div className="subscription-page">
      <div className="subscription-header">
        <button onClick={handleGoBack} className="back-button">
          ← กลับไปที่เกม
        </button>
        <h1>🎮 สมัครสมาชิก</h1>
      </div>
      
      <div className="subscription-content">
        {/* Subscription info box removed */}
        
        <div className="subscription-plans">
          {/* Plan toggle buttons removed */}
          
          <div className="plan-details">
            <h3>Premium Subscription</h3>
            
            <div className="game-image-container">
              <img src="/subimage.png" alt="Subscription" className="subscription-image" style={{ width: '100%', borderRadius: '8px' }} />
            </div>
            
             <div className="subscription-details">
              <p>
                บริการ Fun Game อัตราค่าบริการ 10 บาทต่อ SMS คุณจะได้รับ 1 SMS ต่อ วัน
              </p>
              <p>
                หรือ สมัครโดยพิมพ์ {process.env.REACT_APP_DTAC_KEYWORD || 'YG3'} ส่งมาที่ 4541392<br/>
                สอบถามโทร : 02-1158814, 9.00 - 18.00 (จันทร์ - ศุกร์)<br/>
                ยกเลิกพิมพ์ STOP {process.env.REACT_APP_DTAC_KEYWORD || 'YG3'} ส่งมาที่ 4541392
              </p>
            </div>
            
            {error && <div className="error-message">{error}</div>}
            <button 
              className={`subscribe-button ${isLoading ? 'loading' : ''}`} 
              onClick={handleSubscribe}
              disabled={isLoading}
            >
              {isLoading ? 'กำลังดำเนินการ...' : 'สมัครสมาชิก'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DTACSubscriptionPage;